import React from 'react';
import ModalBoxes from 'common/feedback/ModalBoxes/ModalBoxes';
import { map } from 'lodash/collection';
import { isEmpty } from 'lodash/lang';
import { pick } from 'lodash/object';

import { i18nt } from '../../../../../../../../root';
import { NS_COMMON, NSC_ADDRESS, NSPP_PATIENT } from '../../../../../../../../services/i18n/namespaces';

const fieldsMap = {
  paymentType: i18nt('addOrEdit.paymentCardType', { ns: NSPP_PATIENT }),
  cardId: i18nt('info.pid', { ns: NSPP_PATIENT }),
  ssn: i18nt('ssn', { ns: NSPP_PATIENT }),
  'phonesInfo.primary': i18nt('addOrEdit.primaryPhone', { ns: NSPP_PATIENT }),
  'address.addressLine1': i18nt('address1', { ns: NSC_ADDRESS }),
  'address.zipCode': i18nt('addOrEdit.ZIP', { ns: NSPP_PATIENT }),
  'address.city': i18nt('city', { ns: NSC_ADDRESS }),
  'address.state': i18nt('state', { ns: NSC_ADDRESS }),
  email: i18nt('email', { ns: NS_COMMON })
};

export default function informAboutRequiredFields(validationMessages, info) {
  if (info.address.country !== 'US') {
    return;
  }
  const fields = pick(validationMessages, Object.keys(fieldsMap));
  if (isEmpty(fields) || !info.digitalPaymentAllowed || !info?.paymentType) {
    return;
  }
  return ModalBoxes.confirm({
    title: i18nt('validation.assignPaymentCardType', { ns: NSPP_PATIENT }),
    content: (
      <>
        <p>
          {i18nt('validation.requiredFieldsMissingFor', { ns: NSPP_PATIENT })} {info.paymentType}
          <br />
          {i18nt('validation.fillFieldBeforeSaving', { ns: NSPP_PATIENT })}:
        </p>
        <p>
          {map(fields, function(value, key) {
            return (
              <>
                {fieldsMap[key]}
                <br />
              </>
            );
          })}
        </p>
      </>
    ),
    cancelButton: i18nt('ok'),
    confirmButton: false
  }).then(
    () => {},
    () => {}
  );
}
